type ChangeUsernameCallback = (username: string) => void

const callbacks = new Set<ChangeUsernameCallback>()

/**
 * Registers a callback that will be invoked when the chat username is changed
 * via the public API. Used by active WebSocket connections to propagate
 * username changes to the server.
 *
 * @returns An unsubscribe function that removes the callback.
 */
export function registerChatUsernameCallback(
  cb: ChangeUsernameCallback,
): () => void {
  callbacks.add(cb)
  return () => {
    callbacks.delete(cb)
  }
}

/**
 * Notifies all registered callbacks of a chat username change.
 * Called by the public `_fwn.chat.setUsername` API to propagate
 * the new name to active livestream WebSocket connections.
 */
export function broadcastChatUsernameChange(username: string): void {
  callbacks.forEach((cb) => cb(username))
}
